import request from '@Sys~/api/request'
import { apiUrl, type } from './env'
import store from '@Sys~/store'

var bdc4_url = apiUrl.bdc4_url;
var gms_url = apiUrl.gms_url;
var gm_url = apiUrl.gm_url;
var gateway4 = apiUrl.gateway4 
var host = window.location.protocol+"//"+window.location.host;
if(host.indexOf("localhost:") > -1){
  host = 'http://bdc4.yingxiong.com'
}
function gatewayBac4fn(url, data, method) {
    return request({
        baseURL: gateway4,
        url: url,
        method: method,
        data: data,
        withCredentials: false
    })
}

var ptype = "gms"

export function ajax_zitiaojiandata(data, name) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: name, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }
    return request({
        baseURL: name.substring(0, 3) === 'gm_' ? gm_url : gateway4,
        url: '/api/view/handleControlByCode?type='+ptype+'&' + data,
        method: 'get',
        headers: header,
    })
}

// 获取游戏
export function ajax_gamelist(uid) {
    var header = {
        // header_platform: testpro, // （环境类型）
    }
    return request({
        baseURL: bdc4_url,
        url: '/api/sys/user/getUserDetailById?type='+ptype+'&userId=' + uid + '&serverName=bdc3',
        method: 'get',
        headers: header,
        withCredentials: true,
    })
}


// 点击菜单获取模块
export function ajax_modellist( mid) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_platform: store.getters.environment, // （环境类型）
    }
    return request({
        baseURL: gateway4,
        url: '/api/view/codeView?type='+ptype+'&menuId=' + mid,
        method: 'get',
        headers: header,
    })
}

// 点击添加or修改自定义菜单
export function ajax_addmenu(cid, cname, pids) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_platform: store.getters.environment, // （环境类型）
    }

    if (cid == "") {
        var datas = {
            name: cname,
            userId: parseInt(store.getters.userId),
            gameKey: store.getters.appkey,
            systemId: 25
        }
        if (pids != "") {
            datas.pid = parseInt(pids)
        }
    } else {
        var datas = {
            id: cid,
            name: cname,
            userId: parseInt(store.getters.userId),
            gameKey: store.getters.appkey,
            systemId: 25
        }
        if (pids != "") {
            datas.pid = parseInt(pids)
        }
    }

    datas.type = ptype
    // console.log(datas)

    return request({
        baseURL: bdc4_url,
        url: '/api/sys/menu/saveMenu',
        method: 'post',
        headers: header,
        data: datas,
        withCredentials: true,
    })
}

// 删除菜单
export function ajax_removemenu(cid) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_platform: store.getters.environment, // （环境类型）
    }
    return request({
        baseURL: bdc4_url,
        url: '/api/sys/menu/delMenu?type='+ptype+'&menuId=' + cid + '&userId=' + store.getters.userId,
        method: 'get',
        headers: header,
        withCredentials: true,
    })
}

// 菜单列表 
export function ajax_mymenulist(pid) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_platform: store.getters.environment, // （环境类型）
    }
    // console.log(pid)
    return request({
        baseURL: bdc4_url,
        url: '/api/sys/menu/customMenuByKey?type='+ptype+'&gameKey=' + store.getters.appkey + '&userId=' + store.getters.userId + '&pid=' + pid,
        method: 'get',
        headers: header,
        withCredentials: true,
    })
}

// 菜单列表 
export function ajax_mymenulistfu() {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_platform: store.getters.environment, // （环境类型）
    }
    return request({
        baseURL: bdc4_url,
        url: '/api/sys/menu/customMenuByKey?type='+ptype+'&gameKey=' + store.getters.appkey + '&userId=' + store.getters.userId + '&pid=',
        method: 'get',
        headers: header,
        withCredentials: true,
    })
}

// 指标查询ngxiong.com/api/custom/query
export function customquery(code, data) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }
    data.type = ptype
    return request({
        baseURL: gm_url,
        url: '/api/custom/query',
        method: 'post',
        headers: header,
        data: data
    })
}
// 指标下载
export function customqueryDownload(code, data) {
    data.type = ptype
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }

    var form = document.createElement("form");
    form.style.display = "none";
    form.action = gm_url + "/api/custom/queryDownload";
    form.method = "post";
    document.body.appendChild(form);

    for (var key in data) {
        if (typeof data[key] == 'object') {
            for(var i=0;i<data[key].length;i++){
                for (var key_sub in data[key][i]) {
                    var input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key + '[' + i + '].' + key_sub; 
                    input.value = data[key][i][key_sub];
                    form.appendChild(input);
                }
            }
        }else{
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = key; 
            input.value = data[key];
            form.appendChild(input);
        }
    }
    // "customQueryParam."+
    // console.log(form)
    form.submit();
    form.remove();
}

// 分析查询
export function fenxisave(code, data) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }
    data.type = ptype
    return request({
        baseURL: gm_url,
        url: '/api/custom/save',
        method: 'post',
        headers: header,
        data: data
    })
}
// 分析保存
export function fenxiquery(obj) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    obj.type = ptype
    return request({
        baseURL: gateway4,
        url: '/api/custom/analysis/query',
        headers: header,
        method: 'post',
        data: obj
    })
}


// 查询编辑数据
export function queryByCode(obj) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    return request({
        baseURL: gateway4,
        url: '/api/custom/analysis/queryByCode?type='+ptype+'&code=' + obj,
        headers: header,
        method: 'get'
    })
}

//指标添加列表
export function ajax_zhibiaoliebiao( mid) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    return request({
        baseURL: gateway4,
        url: '/api/custom/analysis/list?type='+ptype+'&menuId=' + mid,
        headers: header,
        method: 'get'
    })
}

//指标应用

export function ajax_createView(datas) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    datas.type = ptype
    return request({
        baseURL: gateway4,
        url: '/api/view/createView',
        headers: header,
        method: 'post',
        data: datas
    })
}
// 删除已存报表
export function ajax_zhibiaodel(bid) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    return request({
        baseURL: gateway4,
        url: '/api/custom/analysis/del?type='+ptype+'&id=' + bid,
        headers: header,
        method: 'get'
    })
}


// 指标布局修改
// /api/sasapi/updateView
export function ajax_updateView(datas) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    // datas.type = ptype
    return request({
        baseURL: gateway4,
        url: '/api/view/updateView',
        headers: header,
        method: 'post',
        data: datas
    })
}

// 分享指定人员列表
export function ajax_shareduserlist(mid) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    return request({
        baseURL: bdc4_url,
        url: '/api/sys/game/getUsersByKey?type='+ptype+'&menuId=' + mid + '&appkey=' + store.getters.appkey,
        headers: header,
        method: 'get',
        withCredentials: true,
    })
}

// 分享指定人员
export function ajax_shareduser(datas) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    datas.type = ptype
    return request({
        baseURL: bdc4_url,
        url: '/api/sys/menu/shared',
        headers: header,
        method: 'post',
        data: datas,
        withCredentials: true,
    })
}


// 分享全员
export function ajax_sharedalluser( mid) {
    var header = {
        header_check_mark: "no",
        header_platform: store.getters.environment, // （环境类型）
        header_appkey: store.getters.appkey, // （游戏appkey）
    }
    return request({
        baseURL: bdc4_url,
        url: '/api/sys/menu/shared?type='+ptype+'&menuId=' + mid,
        headers: header,
        method: 'get',
        withCredentials: true,
    })
}


// 获取用户信息
export function logins() {
    return request({
        baseURL: host,
        url: '/currentUser?type='+ptype,
        method: 'get',
        withCredentials: true,
    })
}



// 站内信未读数
export function ajax_messagecount() {
    return request({
        baseURL: bdc4_url,
        url: "/api/sys/message/count?type="+ptype,
        method: "get",
        data: {},
        withCredentials: true
    })
}
// 站内信未读消息
export function ajax_messageunread() {
    return request({
        baseURL: bdc4_url,
        url: "/api/sys/message/unread?type="+ptype,
        method: "get",
        data: {},
        withCredentials: true
    })
}
// 站内信未读消息
export function ajax_messageinfo(data) {
    return request({
        baseURL: bdc4_url,
        url: "/api/sys/message/" + data +'?type='+ptype,
        method: "get",
        data: {},
        withCredentials: true
    })
}

// 系统公告
export function ajax_messageunread99(data) {
    return request({
        baseURL: bdc4_url,
        url: "/api/sys/message/unread?state="+data+"&type="+ptype,
        method: "get",
        data: {},
        withCredentials: true
    })
}



// 指标查询
export function ajax_handleBusinessByTargetKpi(code, data) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }
    data.type = ptype
    return request({
        baseURL: gms_url,
        url: '/api/data/handleBusinessByTargetKpi',
        method: 'post',
        headers: header,
        data: data
    })
}

// /api/data/handleBusinessByTargetKpi
export function ajax_gm_handleBusinessByTargetKpi(code, data) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }
    data.type = ptype
    return request({
        baseURL: gm_url,
        url: '/api/data/handleBusinessByTargetKpi',
        method: 'post',
        headers: header,
        data: data
    })
}
export function ajax_gm_customqueryTest(code, data) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }
    data.type = ptype
    return request({
        baseURL: gm_url,
        url: '/api/custom/queryTest',
        method: 'post',
        headers: header,
        data: data
    })
}

// 上传
export function ajax_dataupload(data) {
    data.type = ptype
    return request({
        baseURL: gms_url,
        url: '/file/data/upload',
        method: 'post',
        headers: {},
        data: data,
    })
}

// 下载
export function ajax_datadownload(code, datas) {
    datas.type = ptype
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }

    var form = document.createElement("form");
    form.style.display = "none";
    form.action = gms_url + "/file/data/download";
    form.method = "post";
    document.body.appendChild(form);
    for (var key in header) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = header[key];
        form.appendChild(input);
    }
    for (var key in datas) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = datas[key];
        form.appendChild(input);
    }
    // console.log(form)
    form.submit();
    form.remove();
}

// 模板 筛选条件 查询接口
export function ajax_modelQuery(code) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_view_code: code, // （条件名）
        header_platform: store.getters.environment, // （环境类型）
    }
    return request({
        baseURL: gateway4,
        url: '/api/view/rule/query?type='+ptype,
        method: 'post',
        headers: header
    })
}

// 模板 筛选条件 锁定接口（保存接口）
export function ajax_lock(data) {
    var header = {
        header_appkey: store.getters.appkey, // （游戏appkey）
        header_platform: store.getters.environment, // （环境类型）
    }
    data.type = ptype
    return request({
        baseURL: gateway4,
        url: '/api/view/rule/save',
        method: 'post',
        headers: header,
        data: data
    })
}



// 产品文档 菜单详情
export function ajax_wikiinfo(data) {
    return gatewayBac4fn("/api/wiki/info/"+data,{} , "get")
}